import {ActionTypes} from '../constants/ActionTypes';
import actions from '../actions/index';
import {Map, fromJS} from "immutable";

const initialState = [];
const initialUserMap = Map({});
const initialTechLocation = Map({});

const users = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SELECT_USER:
            return selectUser(state, action);
        case ActionTypes.ADD_USER:
            return addUser(state, action);
        case ActionTypes.DELETE_USER:
            if (action.msg === true) {
                return deleteUser(state, action);
            } else {
                return state;
            }
        case ActionTypes.EDIT_USER:
            if (action.msg === true) {
                return editUser(state, action);
            }
    }
    return state;
};

export const getUser = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.CREATE_USER:
            return action.user;
        case ActionTypes.GET_USER_ID:
            return action.userId;
        case ActionTypes.EDIT_USER:
            if (action.msg === false) {
                return action.user;
            }
        case ActionTypes.GET_LOGIN:
            if (action.msg === true) {
                return action.user;
            }
    }
    return state;
};

const usersMap = (state = initialUserMap, action) => {
    switch (action.type) {
        case ActionTypes.SELECT_USER_MAP:
            return selectUserMap(state, action);
    }
    return state;
}

function addUser(state, action) {
    const {users} = action;
    return [...state, ...users];
}

function createUser(state, action) {
    const {users} = action;
    return [...state, ...users];
}

function selectUser(state, action) {
    const {users} = action;
    return users;
}

function selectUserMap(state, action) {
    const {usersMap} = action;
    state = Map({});
    usersMap.map((user) => {
        state = state.set(user.id.toString(), fromJS(user));
    });
    return state;
}


function deleteUser(state, action) {
    let userId = action.userId;
    if (userId > -1) {
        let user = Array();
        user = state;
        user.filter((value, key) => {
            if (value.id === userId) {
                user.splice(key, 1)
                return user;
            }
        })
        return [...user, ...users];
    } else {
        return [...state, ...users];
    }
}

function editUser(state, action) {
    let userRes = action.user;
    let userId = userRes.id;
    let user = Array();
    user = state;
    user.filter((value, key) => {
        if (value.id === userId) {
            value.firstname = userRes.firstname;
            value.lastname = userRes.lastname;
            value.mail = userRes.mail;
            value.projectId = userRes.projectId;
            return user;
        }
    })
    return [...user];
}

const techLocation = (state = initialTechLocation, action) => {
    switch (action.type) {
        case ActionTypes.TECH_LOCATION:
            return getTechLocation(state, action);
    }

    return state;
};

function getTechLocation(state, action) {
    const {techLocation} = action;
    state = Map({});
    techLocation.map((location) => {
        state = state.set(techLocation.id.toString(), location);
    });

    return state;
}

export {users, usersMap, techLocation};


// WEBPACK FOOTER //
// ./src/reducers/users.js